import React, { useState, useEffect, useRef, useCallback } from 'react';
import { Button, TextBox, SelectBox, Switch } from 'devextreme-react';
import data from "../assets/apiRoutes.json";
import Toolbar, { Item } from "devextreme-react/toolbar";
import { connect } from "react-redux";
import { createStore } from 'devextreme-aspnet-data-nojquery';
import { confirm } from "devextreme/ui/dialog";
import { alert } from 'devextreme/ui/dialog';
import { FileUploader } from "devextreme-react/file-uploader";
import RadioGroup from 'devextreme-react/radio-group';
import axios from "axios";
import sitelogo from "../assets/logo.png";
import siteBackground from "../assets/argosBackground.png";
import { TwoFactorAuthenticationSetting } from '../enum/Enum';
import { AppSettingsLocalStorageKey ,APIKey} from '../const/constants';
import ungroupedRoutesData from '../const/RoutesList';

const AppSettings = (props) => {
    var accessToken = props.oidc.user.access_token;
    const [apiKeySaved, setApiKeySaved] = useState(false);
    const twoFactorAuthenticationSettings = [
        { id: TwoFactorAuthenticationSetting.NotRequired, text: TwoFactorAuthenticationSetting.NotRequiredText },
        { id: TwoFactorAuthenticationSetting.RequiredForAllLogins, text: TwoFactorAuthenticationSetting.RequiredForAllLoginsText },
        { id: TwoFactorAuthenticationSetting.RequiredForAllInternalLogins, text: TwoFactorAuthenticationSetting.RequiredForAllInternalLoginsText },
        { id: TwoFactorAuthenticationSetting.RequiredForAllExternalLogins, text: TwoFactorAuthenticationSetting.RequiredForAllExternalLoginsText },
    ];

    const [settings, setSettings] = useState({
        AppTitle: "",
        AppIcon: "",
        AppLogo: "",
        LoginBackground: "",
        NoImage: false,
        isDefault: false,
        Model: "",
        APIKey: "",
        APIEndPoint:"",
        ModelDeployment:"",
        ModelCompany:"",
        EmbeddingModel:"",
        TwoFactorAuthenticationSetting: TwoFactorAuthenticationSetting.NotRequired,
        LoadGridOnPageLoad: true,
        FiltersCollapsed: true,
        RestrictedPages: [],
        /** 'dashboard' | 'classic' — home page quick actions appearance */
        HomeQuickActionsLayout: "classic",
        /** When false, home page does not request or show organization-wide shortcuts */
        ShowGlobalShortcuts: true,
    });
    const [roles, setRoles] = useState([]);
    const [selectedPageForRestriction, setSelectedPageForRestriction] = useState(null);
    const fileUploadersRef = {
        appIcon: useRef(null),
        appLogo: useRef(null),
        loginBackground: useRef(null),
    };

    // Load settings from localStorage on component mount
    useEffect(() => {
        loadDataFromLocalStorage();
        loadRoles();
    }, []);

    // Load roles from API
    const loadRoles = () => {
        axios
            .get(`${window._env_.REACT_APP_AUTH_URL}/${data.idp.loadRoles}`, {
                headers: {
                    access_token: accessToken,
                    Authorization: `Bearer ${accessToken}`,
                },
            })
            .then((res) => {
                setRoles(res.data || []);
            })
            .catch((err) => {
                console.log(err, "error in loading Roles");
            });
    };

    const loadDataFromLocalStorage = () => {
        const storedSettings = localStorage.getItem(AppSettingsLocalStorageKey);
        if (storedSettings) {
            let parsedSettings = JSON.parse(storedSettings);
            parsedSettings.isDefault = parsedSettings.AppLogo === "../images/logo.png";
            if (parsedSettings.APIKey  != null && parsedSettings.APIKey != '')
            {
              setApiKeySaved(true);
            }
            parsedSettings.APIKey = "";
            // Ensure RestrictedPages is initialized as an array
            if (!parsedSettings.RestrictedPages || !Array.isArray(parsedSettings.RestrictedPages)) {
                parsedSettings.RestrictedPages = [];
            }
            if (parsedSettings.HomeQuickActionsLayout !== "classic" && parsedSettings.HomeQuickActionsLayout !== "dashboard") {
                parsedSettings.HomeQuickActionsLayout = "classic";
            }
            if (typeof parsedSettings.ShowGlobalShortcuts !== "boolean") {
                parsedSettings.ShowGlobalShortcuts = true;
            }
            setSettings(parsedSettings);
        }
    };
    
    // Handle text input change
    const handleInputChange = (key, value) => {
        if (key === APIKey) setApiKeySaved(false);
        setSettings(prev => ({ ...prev, [key]: value }));
    };

    // Convert image to Base64 and store
    const handleFileUpload = (key, e) => {
        const file = e.value[0];
        if (file) {
            const reader = new FileReader();
            reader.onloadend = () => {
                setSettings(prev => ({ ...prev, [key]: reader.result }));
            };
            reader.readAsDataURL(file);
        }
    };
    const handleReset = () => {
        Object.values(fileUploadersRef).forEach(ref => {
            if (ref.current) {
                ref.current.instance().reset();
            }
        });
        loadDataFromLocalStorage();
    }
    // Save to localStorage
    const saveSettings = () => {
        const updatedSettings = { ...settings, NoImage: settings.NoImage ? "true" : "false" };

        axios
            .post(
                `${window._env_.REACT_APP_AUTH_URL}/${data.idp.SaveAppSettings}`,
                JSON.stringify(updatedSettings),
                {
                    headers: {
                        "Content-Type": "application/json",
                        access_token: accessToken,
                        Authorization: `Bearer ${accessToken}`,
                    },
                }
            )
            .then((res) => {
                localStorage.setItem(AppSettingsLocalStorageKey, JSON.stringify(settings));
                loadDataFromLocalStorage();
                setApiKeySaved(true);
                window.dispatchEvent(new Event("argos-app-settings-changed"));
                alert("Record saved but IIS must be restarted for the changes related to Chat to take effect.", "Success");

            })
            .catch((err) => {
                console.log(err, "error in loading Roles");
            });

    };
    const chatModels = [
        {
            ID: 'llama3.2',
            Name: 'llama3.2',
        },
        {
            ID: 'gpt-4o-mini',
            Name: 'gpt-4o-mini',
        }
    ];
    const chatModelDeployments = [
        {
            ID: 'Anthropic',
            Name: 'Anthropic',
        },
        {
            ID: 'Github',
            Name: 'Github',
        },
        {
            ID: 'Local',
            Name: 'Local',
        },
        {
            ID: 'OpenAI',
            Name: 'OpenAI',
        } 
    ];
    const chatModelCompany = [
        {
            ID: 'Meta',
            Name: 'Meta',
        },
        {
            ID: 'OpenAI',
            Name: 'OpenAI',
        },
        {
            ID: 'Azure',
            Name: 'Azure',
        },
        {
            ID: 'Anthropic',
            Name: 'Anthropic',
        },
        {
            ID: 'Google',
            Name: 'Google',
        },
        {
            ID: 'Mistral',
            Name: 'Mistral',
        },
        {
            ID: 'Cohere',
            Name: 'Cohere',
        },
        {
            ID: 'Groq',
            Name: 'Groq',
        },
        {
            ID: 'HuggingFace',
            Name: 'HuggingFace',
        } 
    ];
      const onChatModelDeploymentValueChanged = useCallback((e) => {
        handleInputChange("ModelDeployment", e.value);
    }, [handleInputChange]);
    const onChatModelCompanyValueChanged = useCallback((e) => {
        handleInputChange("ModelCompany", e.value);
    }, [handleInputChange]);


    // Handle adding a page to restricted list
    const handleAddRestrictedPage = useCallback((selectedRoute) => {
        if (selectedRoute && selectedRoute.value) {
            const pageToAdd = {
                name: selectedRoute.name,
                value: selectedRoute.value,
                key: selectedRoute.key || ""
            };
            
            // Check if page already exists
            const exists = settings.RestrictedPages.some(page => page.value === pageToAdd.value);
            if (exists) {
                alert("This page is already in the restricted list.", "Duplicate Entry");
                setSelectedPageForRestriction(null);
                return;
            }

            // Show confirmation dialog before adding
            confirm(
                `Are you sure you want to restrict access to "${pageToAdd.name}"?\n\nURL: ${pageToAdd.value}\n\nThis page will be added to the restricted pages list.`,
                "Confirm Restrict Page"
            ).then((dialogResult) => {
                if (dialogResult) {
                    // User clicked Yes
                    setSettings(prev => ({
                        ...prev,
                        RestrictedPages: [...prev.RestrictedPages, pageToAdd]
                    }));
                    setSelectedPageForRestriction(null);
                } else {
                    // User clicked No or closed the dialog
                    setSelectedPageForRestriction(null);
                }
            });
        }
    }, [settings.RestrictedPages]);

    // Handle removing a page from restricted list
    const handleRemoveRestrictedPage = useCallback((pageValue) => {
        setSettings(prev => ({
            ...prev,
            RestrictedPages: prev.RestrictedPages.filter(page => page.value !== pageValue)
        }));
    }, []);

    // Filter routes data for the search box (exclude already restricted pages)
    const availableRoutesForRestriction = ungroupedRoutesData.filter(route => 
        !settings.RestrictedPages.some(restricted => restricted.value === route.value)
    );
    return (
        <div>
            <div className="row dataEntryMainPage"   style={{ 
                    height: 'calc(100vh - 70px)', 
                    overflowY: 'auto', 
                    overflowX: 'hidden', 
                    paddingRight: '8px'
                }} >
                <div className="col-md-12 main-page">
                    <Toolbar className="header">
                        <Item location="before">
                            <div className="title">
                                <h6
                                    style={{
                                        color: window._env_.Color2,
                                        marginLeft: '12px'
                                    }}
                                >
                                    Application Settings
                                </h6>
                            </div>
                        </Item>
                        <Item location="after">
                            <Button
                                text="Save"
                                type="default"
                                className="accordianButton"
                                onClick={saveSettings}
                            />
                        </Item>
                        <Item location="after">
                            <Button
                                text="Reset"
                                className="accordianButton"
                                onClick={handleReset}
                            />
                        </Item>
                    </Toolbar>

                    <div className='row'>
                        <div className='col-md-3'>
                            <fieldset className='col-fieldset' style={{ height: '147px' }} >
                                <legend className="list-title" >App Title</legend>
                                <TextBox labelMode='static' label='App Title' placeholder='App Title' maxLength={25}
                                    stylingMode='outlined' value={settings.AppTitle} onValueChanged={e => handleInputChange("AppTitle", e.value)} style={{ marginTop: '35px' }} />
                                <div />
                            </fieldset>
                        </div>
                        <div className='col-md-3'>
                            <fieldset className='col-fieldset' style={{ height: '147px' }} >
                                <legend className="list-title" >App Icon</legend>
                                {settings.AppIcon && <img src={settings.isDefault ? '../favicon.ico' : settings.AppIcon} alt="App Icon" width="50" height="50" />}
                                <FileUploader accept="image/*" uploadMode="useForm" onValueChanged={e => handleFileUpload("AppIcon", e)} ref={fileUploadersRef.appIcon} />
                            </fieldset>
                        </div>
                        <div className='col-md-3'>
                            <fieldset className='col-fieldset' style={{ height: '147px' }} >
                                <legend className="list-title" >App Logo</legend>
                                {settings.AppLogo && <img src={settings.isDefault ? sitelogo : settings.AppLogo} alt="App Logo" width="50" height="50" />}
                                <FileUploader accept="image/*" uploadMode="useForm" onValueChanged={e => handleFileUpload("AppLogo", e)} ref={fileUploadersRef.appLogo} />
                            </fieldset>
                        </div>
                        <div className='col-md-3'>
                            <fieldset className='col-fieldset' style={{ height: '147px' }} >
                                <legend className="list-title" >Login Background</legend>
                                <div className='row'>
                                    <div className='col-md-6'>{settings.LoginBackground && <img src={settings.isDefault ? siteBackground : settings.LoginBackground} alt="Login Background" width="100" height="50" />}</div>
                                    <div className='col-md-6'><span className="card-item-info">No Image</span> <Switch value={settings.NoImage} onValueChanged={e => handleInputChange("NoImage", e.value)} /></div>
                                </div>
                                <FileUploader accept="image/*" uploadMode="useForm" onValueChanged={e => handleFileUpload("LoginBackground", e)} ref={fileUploadersRef.loginBackground} />
                            </fieldset>
                        </div>
                    </div>
                    <div className='row'>
                        <div className='col-md-12'>
                            <fieldset className='col-fieldset' style={{ height: '135px', marginTop: '10px' }} >
                                <legend className="list-title" >Chat</legend>
                                <div className='row accordianLastRow'>
                                    <div className='col-md-3'>
                                        <TextBox
                                            label="Model"
                                            maxLength={50}
                                            placeholder='Model'
                                            value={settings.Model}
                                            onValueChanged={e => handleInputChange("Model", e.value)}
                                            stylingMode='outlined'
                                            labelMode="static"
                                        />
                                    </div>
                                    <div className='col-md-3'>
                                    <TextBox
                                            label={apiKeySaved ? 'API Key (Saved Encrypted)' : 'API Key'}
                                            stylingMode='outlined'
                                            labelMode="static"
                                            value={settings.APIKey}
                                            onValueChanged={e => handleInputChange("APIKey", e.value)}
                                        />        
                                    </div>
                                    <div className='col-md-3'>
                                        <TextBox labelMode='static' label='API End Point' placeholder='API End Point'  
                                            stylingMode='outlined' value={settings.APIEndPoint} onValueChanged={e => handleInputChange("APIEndPoint", e.value)} />
                                    </div>
                                    <div className='col-md-3'>
                                        <SelectBox
                                            displayExpr="Name"
                                            valueExpr="ID"
                                            dataSource={chatModelDeployments}
                                            label="Model Deployment"
                                            value={settings.ModelDeployment}
                                            onValueChanged={onChatModelDeploymentValueChanged}
                                            stylingMode='outlined'
                                            labelMode="static"
                                        />
                                    </div>
                                </div>
                                <div className='row accordianLastRow'>
                                    <div className='col-md-3'>
                                        <SelectBox
                                            displayExpr="Name"
                                            valueExpr="ID"
                                            dataSource={chatModelCompany}
                                            label="Model Company"
                                            value={settings.ModelCompany}
                                            onValueChanged={onChatModelCompanyValueChanged}
                                            stylingMode='outlined'
                                            labelMode="static"
                                        />
                                    </div>
                                    <div className='col-md-3'>
                                        <TextBox labelMode='static' label='Embedding Model' placeholder='Embedding Model'  
                                            stylingMode='outlined' value={settings.EmbeddingModel} onValueChanged={e => handleInputChange("EmbeddingModel", e.value)} />
                                    </div>
                                </div>
                            </fieldset>
                        </div>
                    </div>
                    <div className='row'>
                        <div className='col-md-12'>
                            <fieldset className='col-fieldset' style={{ marginTop: '10px' }} >
                                <legend className="list-title" >Two-Factor Authentication</legend>
                                    <RadioGroup
                                        items={twoFactorAuthenticationSettings}
                                        defaultValue={TwoFactorAuthenticationSetting.NotRequired}
                                        value={settings.TwoFactorAuthenticationSetting}
                                        valueExpr="id"
                                        displayExpr="text"
                                        layout="horizontal"
                                        onValueChanged={e => {handleInputChange(TwoFactorAuthenticationSetting.TwoFactorAuthenticationSetting, e.value)}}
                                    />
                            </fieldset>
                        </div>
                    </div>
                    <div className='row'>
                        <div className='col-md-12'>
                            <fieldset className='col-fieldset' style={{ marginTop: '10px' }}>
                                <legend className="list-title">Shortcuts</legend>
                                <p style={{ fontSize: '12px', color: '#666', marginBottom: '12px', maxWidth: '48rem' }}>
                                    Home quick actions layout and whether organization-wide shortcuts appear on the home page.
                                    Per-role shortcut pages are configured under <strong>Security → Roles → Manage Settings → Global Shortcuts</strong>.
                                </p>
                                <div className='row' style={{ marginTop: '4px' }}>
                                    <div className='col-md-6'>
                                        <SelectBox
                                            dataSource={[
                                                { value: "dashboard", text: "Workspace dashboard (bento cards, accent widgets)" },
                                                { value: "classic", text: "Classic (stacked sections, bolt headings, green icons)" },
                                            ]}
                                            displayExpr="text"
                                            valueExpr="value"
                                            value={settings.HomeQuickActionsLayout ?? "classic"}
                                            onValueChanged={(e) => handleInputChange("HomeQuickActionsLayout", e.value)}
                                            stylingMode="outlined"
                                            labelMode="static"
                                            label="Home Quick Actions Layout"
                                        />
                                    </div>
                                    <div className='col-md-6 d-flex align-items-center' style={{ marginTop: '8px' }}>
                                        <span className="me-2" style={{ minWidth: '200px' }}>
                                            Show Global Shortcuts On Home
                                        </span>
                                        <Switch
                                            value={settings.ShowGlobalShortcuts !== false}
                                            onValueChanged={(e) => handleInputChange("ShowGlobalShortcuts", e.value)}
                                        />
                                    </div>
                                </div>
                            </fieldset>
                        </div>
                    </div>
                    <div className='row'   > 
                        <div className='col-md-12'>
                            <fieldset className='col-fieldset' style={{ marginTop: '10px' }} >
                                <legend className="list-title" >Restricted Pages</legend>
                                <div className='row' style={{ marginTop: '18px'}}>
                                    <div className='col-md-6'>
                                        <SelectBox
                                            dataSource={availableRoutesForRestriction}
                                            displayExpr={(item) => item ? `${item.name} (${item.value})` : ''}
                                            valueExpr="value"
                                            searchEnabled={true}
                                            searchMode="contains"
                                            searchExpr={["name", "value"]}
                                            showClearButton={true}
                                            placeholder="Search and select a page to restrict..."
                                            value={selectedPageForRestriction}
                                            onValueChanged={(e) => {
                                                if (e.value) {
                                                    const selectedRoute = availableRoutesForRestriction.find(r => r.value === e.value);
                                                    if (selectedRoute) {
                                                        handleAddRestrictedPage(selectedRoute);
                                                    }
                                                } else {
                                                    setSelectedPageForRestriction(null);
                                                }
                                            }}
                                            stylingMode='outlined'
                                            labelMode="static"
                                            label="Add Restricted Page"
                                            itemRender={(item) => {
                                                if (!item) return '';
                                                return (
                                                    <div style={{ padding: '8px' }}>
                                                        <div style={{ fontWeight: '500', fontSize: '14px' }}>{item.name}</div>
                                                        <div style={{ fontSize: '12px', color: '#666', marginTop: '4px' }}>{item.value}</div>
                                                    </div>
                                                );
                                            }}
                                        />
                                    </div>
                                </div>
                                {settings.RestrictedPages && settings.RestrictedPages.length > 0 ? (
                                    <div className='row' style={{ paddingTop: '10px' }}>
                                        <div className='col-md-12'>
                                            <div style={{ 
                                                border: '1px solid #e0e0e0', 
                                                borderRadius: '12px', 
                                                padding: '15px',
                                                backgroundColor: '#fafafa',
                                                maxHeight: '245px',
                                                overflowY: 'auto'
                                            }}>
                                                <div style={{ 
                                                    fontWeight: '500', 
                                                    marginBottom: '10px',
                                                    fontSize: '14px',
                                                    color: '#333'
                                                }}>
                                                    Restricted Pages ({settings.RestrictedPages.length})
                                                </div>
                                                <div style={{ display: 'flex', flexDirection: 'column', gap: '8px', borderRadius: '12px' }}>
                                                    {settings.RestrictedPages.map((page, index) => (
                                                        <div 
                                                            key={index} 
                                                            style={{ 
                                                                display: 'flex', 
                                                                justifyContent: 'space-between', 
                                                                alignItems: 'center',
                                                                padding: '10px 12px',
                                                                backgroundColor: '#fff',
                                                                border: '1px solid #e0e0e0',
                                                                borderRadius: '12px',
                                                                transition: 'all 0.2s ease'
                                                            }}
                                                            onMouseEnter={(e) => {
                                                                e.currentTarget.style.backgroundColor = '#f5f5f5';
                                                                e.currentTarget.style.borderColor = '#007bff';
                                                            }}
                                                            onMouseLeave={(e) => {
                                                                e.currentTarget.style.backgroundColor = '#fff';
                                                                e.currentTarget.style.borderColor = '#e0e0e0';
                                                            }}
                                                        >
                                                            <div style={{ flex: 1 }}>
                                                                <div style={{ fontWeight: '500', fontSize: '14px', color: '#333' }}>
                                                                    {page.name}
                                                                </div>
                                                                <div style={{ fontSize: '12px', color: '#666', marginTop: '4px' }}>
                                                                    {page.value}
                                                                </div>
                                                            </div>
                                                            <Button
                                                                text="Remove"
                                                                type="danger"
                                                                stylingMode="outlined"
                                                                onClick={() => handleRemoveRestrictedPage(page.value)}
                                                                style={{ marginLeft: '15px' }}
                                                            />
                                                        </div>
                                                    ))}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                ) : (
                                    <div className='row' style={{ marginTop: '10px' }}>
                                        <div className='col-md-12'>
                                            <div style={{ 
                                                padding: '20px', 
                                                textAlign: 'center', 
                                                color: '#999',
                                                fontSize: '14px',
                                                fontStyle: 'italic'
                                            }}>
                                                No restricted pages configured. Use the search box above to add pages.
                                            </div>
                                        </div>
                                    </div>
                                )}
                            </fieldset>
                        </div>
                    </div>
                      <div className='row'>
                        <div className='col-md-12'>
                            <fieldset className='col-fieldset' style={{ marginTop: '10px' }} >
                                <legend className="list-title" >Miscellaneous</legend>
                                <div className='row'>
                                    <div className='col-md-3 d-flex align-items-center mb-2'>
                                        <span className="me-2" style={{ minWidth: '180px' }}>Load Grid Data On Page Load</span>
                                        <Switch     
                                            value={settings.LoadGridOnPageLoad} 
                                            onValueChanged={e => handleInputChange("LoadGridOnPageLoad", e.value)} 
                                        />
                                    </div>
                                    <div className='col-md-3 d-flex align-items-center mb-2'>
                                        <span className="me-2" style={{ minWidth: '130px' }}>Collapse Filter Panel</span>
                                        <Switch 
                                            value={settings.FiltersCollapsed} 
                                            onValueChanged={e => handleInputChange("FiltersCollapsed", e.value)} 
                                        />
                                    </div>
                                </div>
                            </fieldset>
                        </div>
                    </div>
                    
                </div>
            </div>
        </div>
    );
};

function mapStateToProps(state) {
    return {
        ReceiptReducer: state.ReceiptReducer,
        oidc: state.oidc,
    };
}

export default connect(mapStateToProps)(AppSettings);
